module.exports = __webpack_public_path__ + "static/media/calendar.a3ec8edc.svg";